// react
// dependencies
import React, { useState } from "react";

import { faAngleRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Spacer from "../../../../../../../components/Spacer";
// components
import GoalSled from "./Sled";

// types
import { Goal } from "../../../../../../../api/services/searchServiceResultTypes/goal";

import Clamp from "../../../../../../../utils/Clamp";

import GoalCard from "../../../../../Common/GoalCard";
import GoalCardSkeleton from "../../../../../Common/GoalCard/GoalCardSkeleton";
//config
import config from "../../config";
// styles
import css from "./Style.module.scss";

type GoalLineageProps = {
	changeActiveGoal: (topGoal) => void;
	sledWidth: number;
	topGoalsList: Array<Goal>;
	isLoading?: boolean;
};

const GoalLineage = ({ changeActiveGoal, sledWidth, topGoalsList, isLoading = false }: GoalLineageProps) => {
	const [sledPosition, setSledPosition] = useState(0);
	const [isGoalAnimatingIndex, setIsGoalAnimatingIndex] = useState<number | null>(null);

	const handleGoalClick = (topGoal) => {
		const index = topGoalsList.findIndex((goal) => goal._id === topGoal._id);
		const goalSubsetIncludingIndex = topGoalsList.slice(0, index + 1);

		setIsGoalAnimatingIndex(index);

		setTimeout(() => {
			setIsGoalAnimatingIndex(null);
			changeActiveGoal(goalSubsetIncludingIndex);
		}, 200);
	};

	const handleChangePosition = (direction: string) => {
		const scrollMargin = 50;
		const goalCardWidth = config.goalsWidth + 22;
		let nextPosition = sledPosition + (direction === "forward" ? -1 : 1) * sledWidth;
		const maxPosition = topGoalsList.length * goalCardWidth - (sledWidth - scrollMargin);

		nextPosition = Clamp(nextPosition, -maxPosition, 0);
		setSledPosition(nextPosition);
	};

	const scrollMargin = 50;
	const goalCardWidth = config.goalsWidth + 22;
	const maxScroll = -1 * (topGoalsList.length * goalCardWidth - (sledWidth - scrollMargin));

	// is at maxposition if less than 10px difference
	const isUnderGoalOverflow = sledWidth >= goalCardWidth * topGoalsList.length;
	const isAtMaxPosition = isUnderGoalOverflow || Math.abs(sledPosition - maxScroll) < 10;

	if (isLoading) {
		return (
			<div>
				<GoalCardSkeleton width={goalCardWidth} className={css.goalSledCard as any} />
				<Spacer height={2} />
			</div>
		);
	}

	return (
		<div className={css.Main} data-testid="goalLineage">
			<div>
				<GoalSled
					onChangePosition={handleChangePosition}
					position={sledPosition}
					style={{ width: topGoalsList.length * (goalCardWidth + 25) }}
					isAtMaxPosition={isAtMaxPosition}
				>
					{topGoalsList.map((goal, index) => {
						const isActiveGoal = index === topGoalsList.length - 1;
						const goalClass = `${css.goalSledCard} ${isActiveGoal ? css.isActiveSledGoal : ""}}`;
						const isExiting = isGoalAnimatingIndex !== null && index > isGoalAnimatingIndex;
						const isEntering =
							index !== 0 && !(isGoalAnimatingIndex !== null && index > isGoalAnimatingIndex);

						return (
							<div
								className={` ${isExiting && css.exiting} ${isEntering && css.entering} `}
								key={`lineage-goal-card-${goal._id}`}
							>
								<GoalCard
									key={goal._id}
									style={{ left: index * (goalCardWidth + 10) }}
									className={goalClass}
									goal={goal}
									isActive={isActiveGoal}
									onClick={handleGoalClick}
								/>

								{index !== topGoalsList.length - 1 && (
									<div
										className={` ${css.arrowContainer} ${isExiting && css.exiting} ${(isEntering || index === 0) && css.entering} `}
										style={{ left: (index + 1) * (goalCardWidth + 10) - 22 }}
									>
										<FontAwesomeIcon icon={faAngleRight} />
									</div>
								)}
							</div>
						);
					})}
				</GoalSled>
			</div>
		</div>
	);
};

export default GoalLineage;
